import { useTranslation } from "react-i18next";
import { Check, ChevronsUpDown, Settings2 } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../../../../ui/command";
import Button from "../../../Button";
import type { Column } from "@tanstack/react-table";

interface ColumnToggleProps {
    columns: Column<any, unknown>[];
}

function getColumnLabel(column: Column<any, unknown>) {
    const header = column.columnDef.header;
    return typeof header === "string" ? header : column.id;
}

function ColumnToggle({ columns }: ColumnToggleProps) {
    const { t } = useTranslation();
    const toggleableColumns = columns.filter((column) => column.getCanHide());

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant="outline">
                    <Settings2 />
                    {t("columns")}
                    <ChevronsUpDown />
                </Button>
            </PopoverTrigger>

            <PopoverContent align="end" className="tw-p-0">
                <Command>
                    <CommandInput placeholder={t("search")} />
                    <CommandList>
                        <CommandEmpty>{t("no-data")}</CommandEmpty>
                        <CommandGroup>
                            {toggleableColumns.map((column) => (
                                <CommandItem
                                    key={column.id}
                                    value={getColumnLabel(column)}
                                    onSelect={() => column.toggleVisibility(!column.getIsVisible())}
                                >
                                    <span className="tw-flex-1">{getColumnLabel(column)}</span>
                                    {column.getIsVisible() && <Check className="tw-h-4 tw-w-4" />}
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}

export default ColumnToggle;
